import { ResponseDataGet } from "../../../../models/responseDataGet";
import {
  EntCropProductionFilter,
  EntCropProductionFilterRepublic,
  EntCropProductionResponse,
  EntCropProductionByRegionItem
} from "./types"
import { agroApi } from "../../../../redux/api/api";

export const cropProductionAnalyticalDataApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({


    getCropProductionAnalyticalDataRepublic: builder.query<EntCropProductionResponse, EntCropProductionFilterRepublic>({
      query: (filter) => ({
        url: "/departments/organic/crop-gross-production-yield/analytical-data/republic",
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getCropProductionAnalyticalDataByRegion: builder.query<ResponseDataGet<EntCropProductionByRegionItem>, EntCropProductionFilter>({
      query: (filter) => ({
        url: "/departments/organic/crop-gross-production-yield/analytical-data/region",
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCropProductionAnalyticalDataRepublicQuery,
  useGetCropProductionAnalyticalDataByRegionQuery,
} = cropProductionAnalyticalDataApi;
